// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1gaE2","colMaxWidth":"Table_colMaxWidth__hbOrU"};